import React from 'react'
import './MyTickets.css'

const GoogleMaps = ({lat,lng}) => {

    const redirectToGoogleMaps = () => {
        const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;
        window.open(googleMapsUrl, '_blank');
      };


  return (
    <div style={{marginLeft:"1em", marginTop:"0.3em", marginBottom:"0.6em"}}>
      <button className='location-button' onClick={redirectToGoogleMaps}>  Open in Google Maps</button>
    </div>
  )
}

export default GoogleMaps